import { render } from "./PhotoSwipeComponent.vue?vue&type=template&id=ab32f558&ts=true"
import script from "./PhotoSwipeComponent.vue?vue&type=script&lang=ts"
export * from "./PhotoSwipeComponent.vue?vue&type=script&lang=ts"

import "photoswipe/dist/photoswipe.css?vue&type=style&index=0&lang=css"
import "./PhotoSwipeComponent.vue?vue&type=style&index=1&id=ab32f558&lang=postcss"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__